module.exports = __webpack_public_path__ + "img/AC.dc5e2292.svg";